"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._FuzzySort = exports.FuzzySort = void 0;
require("core-js/modules/es.function.name.js");
var _react = _interopRequireDefault(require("react"));
var _semanticUiReact = require("semantic-ui-react");
var _2 = require("./..");
var _utils = require("../../../../../common/utils");
var _lodash = _interopRequireDefault(require("lodash"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * FuzzySort consists of a dropdown menu and a variable number of radio buttons.
 *
 * title: title to display
 * name: name used to create radio button group
 * dropdownSelection: selected value for sort dropdown list
 * dropdownList: array of dropdown menu objects ({ label: <string>, value: <string> })
 * radioBtns: Array of button objects for sorting ({ label: <string>, value: <string>, disabled: <bool> })
 * numColumns: Number of columns to use for display of radio buttons
 * radioSelectedValue: selected value for sort radio group
 * handleDropdownSelection:  handler for sort dropdown selection
 * handleRadioSelection: handler for sort radio button changes
 */
var _FuzzySort = function _FuzzySort(_ref) {
  var title = _ref.title,
    name = _ref.name,
    dropdownSelection = _ref.dropdownSelection,
    radioBtns = _ref.radioBtns,
    numColumns = _ref.numColumns,
    radioSelectedValue = _ref.radioSelectedValue,
    dropdownList = _ref.dropdownList,
    handleDropdownSelection = _ref.handleDropdownSelection,
    handleRadioSelection = _ref.handleRadioSelection;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, title && /*#__PURE__*/_react.default.createElement(_semanticUiReact.Header, {
    as: "h3",
    className: "filter-header",
    id: "SortbyHeader"
  }, title), /*#__PURE__*/_react.default.createElement("div", {
    className: "padding-right"
  }, /*#__PURE__*/_react.default.createElement(_2.InlineSelect, {
    search: true,
    selection: true,
    title: title,
    id: "sortBy",
    name: "".concat(name, "-sortBy"),
    value: dropdownSelection,
    handleChange: handleDropdownSelection,
    options: dropdownList,
    ariaDescribedBy: 'SortbyHeader'
  })), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid, {
    doubling: true,
    stackable: true,
    className: "minimal-padding",
    reversed: "mobile",
    padded: "vertically"
  }, /*#__PURE__*/_react.default.createElement(_2.RadioButtonGrid, {
    name: "".concat(name, "-radio-sort"),
    radioButtons: radioBtns,
    numColumns: numColumns,
    radioSelectedValue: radioSelectedValue,
    handleRadioSelection: handleRadioSelection
  })));
};
exports._FuzzySort = _FuzzySort;
_FuzzySort.defaultProps = {
  dropdownSelection: '',
  radioBtns: [{
    label: '',
    value: ''
  }],
  radioSelectedValue: '',
  dropdownList: []
};
_FuzzySort.propTypes = {
  dropdownSelection: _propTypes.default.string,
  radioBtns: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    value: _propTypes.default.string
  })),
  radioSelectedValue: _propTypes.default.string,
  dropdownList: _propTypes.default.arrayOf(_propTypes.default.shape({
    key: _propTypes.default.string,
    value: _propTypes.default.string,
    text: _propTypes.default.string
  })),
  handleDropdownSelection: _propTypes.default.func,
  handleRadioSelection: _propTypes.default.func
};
var FuzzySort = (0, _utils.enhance)(_FuzzySort);
exports.FuzzySort = FuzzySort;